import { LogOutIcon, SettingsIcon, UserIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'

import { UserAvatarInfo } from './user-avatar-info.atom'

interface SidebarUserMenuContentProps {
  user: {
    name: string
    email: string
    imageUrl: string | null
  }
  isMobile: boolean
  profileUrl: string
  settingsUrl: string
  onSignOut: () => void
}

export const SidebarUserMenuContent = ({
  user,
  isMobile,
  profileUrl,
  settingsUrl,
  onSignOut,
}: SidebarUserMenuContentProps): ReactNode => (
  <DropdownMenuContent
    className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
    side={isMobile ? 'bottom' : 'right'}
    align="end"
    sideOffset={4}
  >
    <DropdownMenuLabel className="p-0 font-normal">
      <UserAvatarInfo
        name={user.name}
        email={user.email}
        imageUrl={user.imageUrl}
        className="px-1 py-1.5"
      />
    </DropdownMenuLabel>
    <DropdownMenuSeparator />
    <DropdownMenuItem asChild>
      <Link to={profileUrl}>
        <UserIcon className="mr-2 h-4 w-4" />
        Profile
      </Link>
    </DropdownMenuItem>
    <DropdownMenuItem asChild>
      <Link to={settingsUrl}>
        <SettingsIcon className="mr-2 h-4 w-4" />
        Settings
      </Link>
    </DropdownMenuItem>
    <DropdownMenuSeparator />
    <DropdownMenuItem onClick={onSignOut}>
      <LogOutIcon className="mr-2 h-4 w-4" />
      Sign out
    </DropdownMenuItem>
  </DropdownMenuContent>
)
